import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PodcastService } from 'src/app/services/podcast.service';
import { Podcast } from 'src/models/podcast';
import { Episode } from 'src/models/episode';
import { PlayerService } from 'src/app/services/player.service';
import { UserService } from 'src/app/services/user.service';
import { combineLatest } from 'rxjs';
import { Stream } from 'src/models/stream';

@Component({
  selector: 'app-podcast-detail',
  templateUrl: './podcast-detail.component.html',
  styleUrls: ['./podcast-detail.component.scss']
})
export class PodcastDetailComponent implements OnInit {

  private podcastId: string;

  public podcast: Podcast;

  public recommendations: Array<Podcast>;

  //public isFavorite = false;

  public currentPlayingId;

  private autoPlay: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private podcastService: PodcastService,
    private playerService: PlayerService,
    private userService: UserService) {
      this.autoPlay = this.router.getCurrentNavigation().previousNavigation !== null // autoplay only if not new window
                        && (this.router.getCurrentNavigation().extras.state === undefined || this.router.getCurrentNavigation().extras.state.autoplay !== false);
    }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.podcastId = params['id'];

      this.podcastService.getPodcast(this.podcastId, undefined).subscribe((podcast: Podcast) =>  {
        this.podcast = podcast;

        if (this.autoPlay && this.podcast.episodes !== undefined && this.podcast.episodes.length > 0) {
          this.onPlayEpisodeClicked(this.podcast.episodes[0]);
        }
      });

      this.podcastService.getRecommendedPodcasts(this.podcastId).subscribe((podcasts: Array<Podcast>) => {
        this.recommendations = podcasts;
      });
    });

    /*this.userService.getFavorites().subscribe((streams: Stream[]) => {
      const streamFound = streams.find((fav: Stream) => fav.id.toString() === this.podcast.id);

      this.isFavorite = streamFound !== undefined;
    });*/

    combineLatest(this.playerService.currentStream, this.playerService.isPlaying).subscribe(([stream, isPlaying]) => {
      this.currentPlayingId = isPlaying ? stream.id.toString() : undefined;
    });
  }

  public loadOlderPodcasts() {
    this.podcastService.getPodcast(this.podcastId, this.podcast.nextEpisodePubDate).subscribe((podcast: Podcast) =>  {
      this.podcast.episodes = this.podcast.episodes.concat(podcast.episodes);

      this.podcast.nextEpisodePubDate = podcast.nextEpisodePubDate;
    });
  }

  public onPlayEpisodeClicked(episode: Episode) {

    if (this.currentPlayingId !== undefined && episode.id === this.currentPlayingId.toString()) {
        this.playerService.pause();
      } else {
        this.playerService.setCurrentStream(episode);
      }
  }

}
